import dompurify from "dompurify";
const EXCEPTIONS = {
  ADD_TAGS: ["iframe", "embed", "object", "style"],
  ADD_ATTR: ["class", "target", "allowfullscreen"],
};

export const sanitize = (html) => {
  dompurify.addHook("afterSanitizeAttributes", (node) => {
    if ("target" in node) {
      if (node.target == "_blank")
        node.setAttribute("rel", "noopener noreferer");
    }
  });

  return dompurify.sanitize(html, EXCEPTIONS);
};

export default {
  sanitize,
};
